'use strict';

angular.module('app')

.directive('uefaLoginForm', function () {
    return {
        restrict: 'E',
        scope: {},
        bindToController: {
            onLogin: '&'
        },
        controller: 'LoginFormCtrl',
        controllerAs: '$ctrl',
        templateUrl: 'directives/login/uefaLoginForm.html'
    };
});
